"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackingPagesCheck = void 0;
const react_1 = __importDefault(require("react"));
const polaris_1 = require("@shopify/polaris");
const StyledMainContainer_1 = require("components/Dashboard/StyledMainContainer");
const StyledHeaderContainer_1 = require("components/Dashboard/StyledHeaderContainer");
const StyledHeader_1 = require("components/Dashboard/StyledHeader");
const EmptyState_1 = require("components/Dashboard/TrackingPages/EmptyState");
const TrackingPagesCheck = ({ action, message, title }) => (react_1.default.createElement("div", { className: 'fade show' },
    react_1.default.createElement(StyledMainContainer_1.StyledMainContainer, { className: 'tracking-pages' },
        react_1.default.createElement(StyledHeaderContainer_1.StyledHeaderContainer, null,
            react_1.default.createElement(StyledHeader_1.StyledHeader, { "aria-level": 1, className: 'header', role: 'heading' }, "Tracking Page Creator")),
        react_1.default.createElement(polaris_1.LegacyCard, { footerActionAlignment: 'left', primaryFooterAction: {
                content: action.content,
                external: action.external,
                url: action.url
            }, sectioned: true, title: title },
            react_1.default.createElement("p", null, message)),
        react_1.default.createElement(EmptyState_1.EmptyState, { isActionDisabled: true }))));
exports.TrackingPagesCheck = TrackingPagesCheck;
